export default __webpack_public_path__ + "static/media/load.a1cb3efe.gif";